import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-[#008080] p-2 min-h-screen flex items-center justify-center font-win95">
      <div className="bg-[#C0C0C0] border-2 border-white shadow-win95 rounded-none w-full max-w-2xl">
        {/* Window Title Bar */}
        <div className="bg-gradient-to-r from-[#000080] to-[#1084D0] text-white flex justify-between p-1">
          <span className="font-bold text-sm">Privacy Policy</span>
          <div className="flex space-x-1">
            <button className="win95-button">-</button>
            <button className="win95-button">□</button>
            <button className="win95-button text-red-600">✕</button>
          </div>
        </div> 

        {/* Content Area */}
        <div className="p-4 space-y-4 text-black">
          <h1 className="text-2xl font-bold border-b-2 border-gray-400 pb-2">
            Privacy Policy
          </h1>

          <div className="space-y-4">
            <div>
              <h2 className="font-bold mb-2">1. Information We Collect</h2>
              <ul className="list-disc pl-6">
                <li>Personal information (name, email address, phone number)</li>
                <li>Account credentials</li>
                <li>Payment information</li>
                <li>Communication and support records</li>
              </ul>
            </div>

            <div>
              <h2 className="font-bold mb-2">2. How We Use Your Information</h2>
              <ul className="list-disc pl-6">
                <li>Provide, maintain, and improve our services</li>
                <li>Process transactions and send related information</li>
                <li>Send you technical notices, updates, security alerts</li>
                <li>Respond to your comments and questions</li>
                <li>Communicate with you about products, services, and events</li>
              </ul>
            </div>

            <div>
              <h2 className="font-bold mb-2">3. Information Sharing</h2>
              <ul className="list-disc pl-6">
                <li>Service providers and business partners</li>
                <li>Legal and regulatory authorities, when required</li>
                <li>In connection with a merger, sale, or asset transfer</li>
              </ul>
            </div>

            <div>
              <h2 className="font-bold mb-2">4. Data Security</h2>
              <p>
                We use reasonable measures to help protect information about you from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.
              </p>
            </div>
          </div>

   

          <div className="text-xs text-gray-700 text-center mt-2">
            Last Updated: {new Date().toLocaleDateString()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;